import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Navbar from './components/Navbar';
import Screens from './pages/Screens';
import Assets from './pages/Assets';
import Playlists from './pages/Playlists';
import Schedules from './pages/Schedules';
import LayoutEditor from './pages/LayoutEditor';
import EquipmentProfile from './pages/EquipmentProfile';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import PersonalProfile from './pages/PersonalProfile';
import PaymentSettings from './pages/PaymentSettings';
import SubscriptionPlan from './pages/SubscriptionPlan';
import SelectPlan from './pages/SelectPlan';
import Payment from './pages/Payment';
import TvPower from './pages/TvPower';
import VideoBuilder from './pages/VideoBuilder';
import Programs from './pages/Programs';
import ProgramBuilder from './pages/ProgramBuilder';
import './App.css';

// Protected Route wrapper
function ProtectedRoute({ children }) {
  const { currentUser } = useAuth();
  
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
}

// Main app content with navbar
function AppContent() {
  return (
    <div className="app">
      <Navbar />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Navigate to="/screens" replace />} />
          <Route path="/screens" element={<Screens />} />
          <Route path="/assets" element={<Assets />} />
          <Route path="/playlists" element={<Playlists />} />
          <Route path="/schedules" element={<Schedules />} />
          <Route path="/video-builder" element={<VideoBuilder />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/programs/new" element={<ProgramBuilder />} />
          <Route path="/programs/:id/edit" element={<ProgramBuilder />} />
          <Route path="/layout/new" element={<LayoutEditor />} />
          <Route path="/layout/:layoutId" element={<LayoutEditor />} />
          <Route path="/equipment-profile" element={<EquipmentProfile />} />
          <Route path="/personal-profile" element={<PersonalProfile />} />
          <Route path="/payment-settings" element={<PaymentSettings />} />
          <Route path="/subscription" element={<SubscriptionPlan />} />
          <Route path="/tv-power" element={<TvPower />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/select-plan" element={<SelectPlan />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/*" element={
            <ProtectedRoute>
              <AppContent />
            </ProtectedRoute>
          } />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;